import {convertCookieToExpired} from '@utils/convertCookieToExpired';
import {RequestCookie} from 'next/dist/compiled/@edge-runtime/cookies';

const getCookie = (name: string): RequestCookie | undefined => {
    const nameEq = name + '=';
    const cookiesArr = document.cookie.split(';');
    for (let i = 0; i < cookiesArr.length; i++) {
        let c = cookiesArr[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEq) == 0) {
            return {name, value: c.substring(nameEq.length, c.length)};
        }
    }
    return undefined;
};

const setCookie = (name: string, value: string) => {
    document.cookie = `${name}=${value}`;
};

const deleteCookie = (name: string) => {
    document.cookie = `${convertCookieToExpired(name)}`;
};

const getAllCookies = (): RequestCookie[] => {
    return document.cookie.split(';').map(cookie => {
        const [name, value] = cookie.split('=');
        return {name, value};
    });
};

export const ClientCookies = {
    set: setCookie,
    get: getCookie,
    delete: deleteCookie,
    getAll: getAllCookies,
};
